<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-7/12 w-full mt-2 border-right-sec">
        <div class="mt-5 chekin-type">
          <p>Check-in Type <span class="rqrd">*</span></p>
          <div class="mt-3">
            <ul class="centerx flex justify-start items-start">
          
              <li>
                <vs-radio
                  v-model="checkinType"
                  color="#00ccfe"
                  vs-value="Self"
                  class="mr-3"
                  >Self</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="checkinType"
                  color="#00ccfe"
                  vs-value="Group"
                  class="mr-3"
                  >Group</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="checkinType"
                  color="#00ccfe"
                  vs-value="Both"
                  >Self & Group</vs-radio
                >
              </li>

              <li class="ml-1">
                <vs-radio
                  v-model="checkinType"
                  color="#00ccfe"
                  vs-value="Remote"
                  >Private</vs-radio
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="mt-5 chekin-type">
          <p>Open Location <span class="rqrd">*</span></p>
          <div class="mt-3">
            <ul class="centerx flex justify-start items-start">
              <li>
                <vs-radio
                  v-model="data_local.OpenLocation"
                  color="#00ccfe"
                  vs-value="Yes"
                  class="mr-5"
                  >Yes</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="data_local.OpenLocation"
                  color="#00ccfe"
                  vs-value="No"
                  class="mr-5"
                  >No</vs-radio
                >

              </li>
            </ul>
          </div>
        </div>
        <div class="checkin-add-form-location mt-2">

          <label>Location Name <span class="rqrd">*</span></label>
          <input
            type="text"
            name="locName"
            id=""
            placeholder="Location Name"
            v-model="data_local.Name"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('locName')"
            >The Location Name field is required</span
          >
          <!-- <label>Address</label>
              <input type="text" name="" id="" placeholder="Add Location"/> -->
        </div>

        <div class="checkin-add-form-location" v-if="checkinType != 'Remote'">
          <label>
            Address
            <span class="rqrd">*</span>
          </label>
          <input
            type="text"
            name="Address"
            id=""
            placeholder="Address"
            v-model="data_local.Address"
            @keyup="getAddressAutocomplete()"
            v-validate="'required'"
            autocomplete="off"
            @change="fetchCoordinatesByAddress()"
          />
          <!-- <textarea
            rows="5"
            class="inputx w-full"
            name="Address"
            v-model="data_local.Address"
            @keyup="getAddressAutocomplete()"
            v-validate="'required'"
            autocomplete="off"
          >
          </textarea> -->
          <ul>
            <li
              v-for="(result, i) in searchResults"
              :key="i"
              @click="setAddress(result)"
            >
              {{ result }}
            </li>
          </ul>
          <span class="text-danger text-sm" v-show="errors.has('Address')"
            >The Address Name field is required</span
          >
        </div>
        <div class="map-find-area" v-if="checkinType != 'Remote'">
          <!-- <div class="map-find-button flex justify-center items-center d-none">
            <vs-button color="#000" type="border" class="find-map-button"
              >FIND ON MAP</vs-button
            >
            <vs-button color="#000" type="border" class="current-location"
              >CURRENT LOCATION (GPS)</vs-button
            >
          </div> -->
          <div class="map-area">
            <GmapMap
              ref="mapRef"
              :center="Coordinates"
              :zoom="15"
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: true,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUI: false,
              }"
              map-type-id="terrain"
              style="width: 100%; height: 250px"
            >
              <GmapCircle
                :clickable="true"
                :draggable="true"
                :center="Coordinates"
                :radius="locationRadius"
                :visible="true"
                :options="{
                  strokeColor: '#FF0000',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                }"
              ></GmapCircle>
              <GmapMarker
                :position="Coordinates"
                :clickable="true"
                :draggable="true"

                @click="updateCoordinates"
              />
            </GmapMap>
          </div>
          <div class="radius-covered-area">
            <label>Covered Radius (Meter)</label>
            <vs-input-number v-model="locationRadius" min="1" />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-5/12 w-full mt-2">
        <div class="location_image_upload">
          <div class="Location-image-area">
            <feather-icon  v-show="!imgSrc"
              icon="ImageIcon"
              svgClasses="h-12 w-12"
              @click="openFileUpload"
            />
            <img
                v-show="imgSrc"
                :src="imgSrc"
                class=""
              />
          </div>
          <h4>Upload to add<br />location image</h4>
          <p>
            Image should be 1:1 ratio in PNG, JPG, SVG<br />Max file size 2MB
          </p>
          <div class="choosefile-button">
            <input
                id="uploadLocImg"
                type="file"
                class="hidden"
                ref="update_location_input"
                @change="update_avatar($event, '200x200')"
                accept="image/*"
              />
            <p  @click="openFileUpload">Choose File</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center align-center mt-8">
      <vs-button color="#d1d3d7" type="border" class="cancel-line-button mr-2" @click="closeLocationPopup()"
        >CANCEL</vs-button
      >
      <vs-button v-if="data_local && data_local.LocationId"
        :disabled="!validateForm"
        @click="before_save(false)"
        color="#00ccfe"
        type="filled"
        class="add-line-button"
        >Update</vs-button
      >
      <vs-button v-else
        :disabled="!validateForm"
        @click="before_save(false)"
        color="#00ccfe"
        type="filled"
        class="add-line-button"
        >ADD</vs-button
      >
    </div>

    <vs-popup
      title="Inner popup"
      class="location-added-popup"
      :active.sync="successPopupOnLocationAdd"
    >
      <div class="location-added-inner">
        <div class="location-add-successful-popup">
          <img src="../../../assets/images/checkin-images/success-tick.png" />
        </div>
        <h2>The new location has been successfully added.</h2>
        <vs-button
          @click="successPopupOnLocationAdd = false"
          color="#00ccfe"
          type="filled"
          class="add-line-button"
          >GREAT</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      v-if="cropImageUrl"
      style="z-index: 53001"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

import ls from "@/common/localStorage";
var cn = ls.getSessionEventCollectionName();

import con from "@/firebase/firebaseInit.ts";
import PhotowallResizeComponent from "../../photowall/PhotowallResizeComponent.vue";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

var gmapApiKey = con.googleMapApiKey;

Vue.use(VueGoogleMaps, {
  load: {
    key: gmapApiKey,
    libraries: "places",
    installComponents: true,
  },
});

//Vue.use(VueCryptojs);

export default {
  components: {
    PhotowallResizeComponent
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    currentLoc:{
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkinType: 'Both',
      successPopupOnLocationAdd: false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      Coordinates: this.data && this.data.Location && this.data.Location['_latitude'] ? {lat: this.data.Location['_latitude'], lng: this.data.Location['_longitude'] } : {lat: this.currentLoc.Latitude, lng: this.currentLoc.Longitude },
      searchResults: [],
      service: null,
      locationRadius: this.data && this.data.CoveredRadius ? this.data.CoveredRadius : 500,
      resetCropper: 0,
      cropImageUrl: null,
      popupCropper: false,
      displayImageRatio: "1:1",
      imageRatio: 1 / 1,
      imgSrc: this.data.ImageUrl == "" ||
        this.data.ImageUrl == undefined
          ? ""
          : this.data.ImageUrl
    };

  },
  computed: {
    
    validateForm() {
      return !this.errors.any();
    },
    // imgSrc: function () {
    //   if (this.data_local.ImageUrl != null) {
    //     return this.data_local.ImageUrl;
    //   } else {
    //     return "";
    //   }
    // },
  },
  watch: {},
  methods: {
    closeLocationPopup(){
      this.data_local = [];
      this.imgSrc = "";
      this.locationRadius = 500;
      this.$emit("closeLocationPopup", 1);

    },
    croppedImagePath(blob) {
      console.log("blob====",blob);
      this.imgSrc = blob;
      this.popupCropper = false;
    },
    update_avatar(input, fileWH) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.data_local.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
          //this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    openFileUpload() {
      $("#uploadLocImg").click();
    },
    saveSingleLocation() {
      if (!this.validateForm) return;

      this.$vs.loading();
      this.data_local.CheckinType = this.checkinType;
      this.data_local.IsPublished = true;
      this.data_local.ImageUrl = this.imgSrc;
      this.data_local.Latitude = this.Coordinates.lat
        ? this.Coordinates.lat
        : this.data_local.Location["_latitude"];
      this.data_local.Longitude = this.Coordinates.lng
        ? this.Coordinates.lng
        : this.data_local.Location["_longitude"];

        this.data_local.Radius = this.locationRadius;

      const Id = this.data_local.LocationId;
      this.data_local.OpenLocation = this.data_local.OpenLocation == 'No' ? false : true;


      console.log("data_local====",this.data_local);

      if (Id) {
        this.$store
          .dispatch("checkinlocationManagement/updateLocation", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Location",
                text: "Location updated successfully.",
              });
              this.$emit("saveLocationSuccess", 1);
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "success",
                text: "Location not updated successfully.",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Speaker",
              text: "Something went wrong!",
            });
          });
      } else {
        console.log("2");

        this.$store
          .dispatch("checkinlocationManagement/addLocation", {
            data: this.data_local,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Location",
                text: "Location created successfully.",
              });
              this.$emit("saveLocationSuccess", 1);
            } else if (res.status == 500) {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                title: "Location",
                text: res.message,
              });
            } else {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                title: "Location",
                text: res.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "Location",
              text: "Something went wrong!",
            });
          });
      }
    },
    defaultValues() {
      if (this.data_local && this.data_local.Name) {
        this.data_local.OpenLocation = this.data_local.OpenLocation == false ? 'No' : 'Yes';
        this.checkinType = this.data_local.CheckinType;
        
      } else {
        this.checkinType = "Both";
        this.data_local.OpenLocation = "Yes";
        
      }
    },
    onChangeLatLong() {
      if (this.Coordinates.lat && this.Coordinates.lng) {
        this.fetchAddressByCoordinates();
        this.fetchCoordinatesByAddress();
      }
    },

    updateCoordinates(location) {
      this.Coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      //this.fetchAddressByCoordinates();
    },
    fetchAddressByCoordinates() {
      let data = {
        coordinates: this.Coordinates,
        gmapApiKey: gmapApiKey,
      };
      this.$store
        .dispatch("venueManagement/fetchAddressByCoordinates", data)
        .then((res) => {
          this.data_local.Address = res.data.formatted_address;
          this.data_local.Country = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "country"
          );
          this.data_local.City = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "locality"
          );
          this.data_local.ZipCode = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "postal_code"
          );
        });
    },
    fetchCoordinatesByAddress() {
      let data = {
        Address: this.data_local.Address,
        gmapApiKey: gmapApiKey,
      };
      this.$store
        .dispatch("venueManagement/fetchCoordinatesByAddress", data)
        .then((res) => {
          this.Coordinates = res.data.geometry.location;
          this.data_local.Country = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "country"
          );
          this.data_local.City = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "locality"
          );
          this.data_local.ZipCode = this.getDataFromGeoAddressComponents(
            res.data.address_components,
            "postal_code"
          );
        });
    },
    getDataFromGeoAddressComponents(addrComponents, checkField) {
      for (var i = 0; i < addrComponents.length; i++) {
        if (addrComponents[i].types[0] == checkField) {
          return addrComponents[i].long_name;
        }
        if (addrComponents[i].types.length == 2) {
          if (addrComponents[i].types[0] == "political") {
            return addrComponents[i].long_name;
          }
        }
      }
      return null;
    },
    setAddress(result) {
      this.data_local.Address = result;
      this.searchResults = [];
      this.fetchCoordinatesByAddress();
    },
    getAddressAutocomplete() {
      if (this.data_local.Address) {
        this.service.getPlacePredictions(
          {
            input: this.data_local.Address,
            //types: ['(cities)']
          },
          this.displaySuggestions
        );
      }
    },
    MapsInit() {
      this.service = new window.google.maps.places.AutocompleteService();
    },
    displaySuggestions(predictions, status) {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        this.searchResults = [];
        return;
      }
      this.searchResults = predictions.map(
        (prediction) => prediction.description
      );
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.data_local.Address = addressData;
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveSingleLocation();
        }
      });
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
  },
  mounted() {
    if(this.$refs.mapRef){
      this.$refs.mapRef.$mapPromise.then((map) => {
      this.MapsInit();
    });
    }
    this.defaultValues();
    /*var data = "clientid=C1594146761016";
    var key  = this.CryptoJS.enc.Latin1.parse('1234567812345678');
    var iv   = this.CryptoJS.enc.Latin1.parse('1234567812345678');  
    var encrypted = this.CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:this.CryptoJS.mode.CBC,padding:this.CryptoJS.pad.ZeroPadding
    });
    console.log('encrypted: ' + encrypted) ;
    var decrypted = this.CryptoJS.AES.decrypt(encrypted,key,{iv:iv,padding:this.CryptoJS.pad.ZeroPadding});
    console.log('decrypted: '+decrypted.toString(this.CryptoJS.enc.Utf8));*/
  },
  created() {},
};
</script>

   
   
   